import { getGardien } from "@/data/gardiens";

export const GardienAvatar = ({ id, className = "w-16 h-16", familiar = true }) => {
  const g = getGardien(id);
  const f = familiar && g.familiar;
  return (
    <span className="relative inline-flex shrink-0" data-testid={f ? `gardien-familiar-${g.id}` : undefined}>
      <img src={g.image} alt={g.name} title={`${g.name} — ${g.value}`}
        className={`${className} rounded-full object-cover object-top border-2 shrink-0`}
        style={{ borderColor: `${g.color}55` }} />
      {f && (
        <img src={g.familiar.image} alt={g.familiar.name} title={`${g.familiar.name}, ${g.familiar.title}`}
          className="absolute -bottom-1 -right-1 w-[42%] h-[42%] rounded-full object-cover border-2 border-white shadow-md"
          style={{ boxShadow: `0 0 0 2px ${g.color}55` }} />
      )}
    </span>
  );
};

export const FamiliarLine = ({ g, className = "" }) =>
  g.familiar ? (
    <p className={`text-sm text-foreground/70 ${className}`} data-testid="gardien-familiar-line">
      avec son fidèle compagnon <b className="font-semibold text-foreground">{g.familiar.name}</b>, {g.familiar.title}
    </p>
  ) : null;

export const GardienBadge = ({ id, eyebrow, quote, size = "md", className = "", testId }) => {
  const g = getGardien(id);
  const big = size === "lg";
  return (
    <div data-testid={testId || `gardien-badge-${g.id}`}
      className={`soft-in flex items-center gap-5 bg-warm/10 border border-warm/25 rounded-3xl ${big ? "p-6 sm:p-7" : "p-4 sm:p-5"} ${className}`}>
      <GardienAvatar id={g.id} className={big ? "w-24 h-24 sm:w-28 sm:h-28 gentle-float" : "w-16 h-16 sm:w-20 sm:h-20"} />
      <div className="min-w-0 text-left">
        {eyebrow && <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">{eyebrow}</p>}
        <p className={`font-serif-display ${big ? "text-2xl sm:text-3xl" : "text-xl sm:text-2xl"} mt-1 text-foreground`}>
          {g.name} <span className="text-sm text-muted-foreground font-sans">· {g.title}</span>
        </p>
        <p className="text-xs uppercase tracking-[0.2em] mt-1 font-semibold" style={{ color: g.color }}>{g.value}</p>
        <FamiliarLine g={g} className="mt-1" />
        <p className={`font-serif-display italic text-foreground/75 mt-2 leading-snug ${big ? "text-lg sm:text-xl" : "text-base"}`}>
          « {quote || g.quote} »
        </p>
      </div>
    </div>
  );
};
